export default __webpack_public_path__ + "static/media/gear.8bb0fc23.svg";